export enum WsEventTypes {
  VersionChange = 'VERSION_CHANGED', // 任务的版本状态发生变更
  BuyArtAssetChange = 'ASSET_ORDER', // 购买资产状态变更
  TaskQueueUpdateStatus = 'UPDATE_STATUS', // 任务队列状态变更
  P4vChange = 'P4V_CHANGED', // 重新获取p4v推送记录
  Alert = 'ALERT', // 消息变更
  InstanceReady = 'INSTANCE_READY', // 实例准备完毕
  EnterpriseTransFail = 'ENTERPRISE_TRANSFER_FAIL', // 企业认证打款失败
  RefreshAuthInfo = 'REFRESH_AUTH_INFO', // 刷新用户认证信息
  RefreshPaymentInfo = 'REFRESH_PAYMENT_INFO', // 刷新用户支付信息
  RefreshUserInfo = 'REFRESH_USER_INFO', // 刷新用户信息，待监听
  RealNamePre = 'REAL_NAME_PRE', // 实名认证预审核
  WithdrawPre = 'WITHDRAW_PRE', // 提现预审核
  ContractSign = 'CONTRACT_SIGN', // 合同签署状态

  LiveAuth = 'LIVE_AUTH', // 扫码 h5 活体检测结果推送

  RefreshApplyInfo = 'REFRESH_APPLY_INFO',
  RefreshParentTaskInfo = 'REFRESH_PARENT_TASK_INFO',
  VersionStatusChange = 'VERSION_STATUS', // 版本状态变更
  DccStatusChange = 'DCC_STATUS', //质检状态变更
  PaymentStatus = 'PAYMENT_STATUS', // 支付状态变更
  WorkshopOrderStatus = 'WORKSHOP_ORDER_STATUS', // 工坊订单变更
}
